import { FormMaxWidth } from 'modules/layout/styled';
import { mediaQuery } from 'modules/utils';
import styled from 'styled-components';

export const FormContainer = styled.form<{ width?: string }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1.563rem;

  ${mediaQuery('md')} {
    > * {
      width: ${(props) => props?.width || FormMaxWidth};
      max-width: ${(props) => props?.width || FormMaxWidth};
    }
  }
`;
